export const Langs = [
  'es'
]



// WEBPACK FOOTER //
// ./src/customization/CustomPackage/langs.js